import {SHOW_MESSAGE, HIDE_MESSAGE, SHOW_ERRORS, HIDE_ERRORS} from '../actions/types/messageTypes';

const initialState = {message: '', show: false, errors: []};

export default function (state = initialState, action) {

  switch (action.type) {

    case SHOW_MESSAGE:

      return {
        ...state,
        message: action.result,
        show: true,
      };

    case HIDE_MESSAGE:

      return {
        ...state,
        message: '',
        show: false,
      };

    case SHOW_ERRORS:

      return {
        ...state,
        errors: action.result,
      };

    case HIDE_ERRORS:

      return {
        ...state,
        errors: [],
      };

    default:
      return state;

  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/messageReducer.js